import { useEffect } from 'react';

const SITE_NAME = 'דביר הנדסה ובניה';

// מעדכן את כותרת הדף ותיאור המטא — חשוב לקידום בגוגל ולתצוגה בשיתופים.
function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute('content', description);
    }
  }, [title, description]);
}

export default usePageMeta;
